import React from 'react'
import PropTypes from 'prop-types'
import { Typography, StackView, Tooltip } from '@telus-uds/components-web'
import { components } from '@digital-commerce/shared-utils'
import { InlineTooltip } from './styles'
import useTranslate from '../../../hooks/useTranslate'

const MonthlyChargesTooltip = ({ showTooltip = false, dataTestId }) => {
  const { ShouldRender } = components
  const translate = useTranslate()
  const t = (key) => translate(`priceSummary.paymentBreakdown.monthlyChargesTooltip.${key}`)

  return (
    <ShouldRender when={showTooltip}>
      <InlineTooltip>
        <Tooltip
          testID={`${dataTestId}-tooltip`}
          content={
            <StackView space={2}>
              <Typography variant={{ size: 'medium', colour: 'white' }}>
                {t('firstSentence')}
              </Typography>
              <Typography variant={{ size: 'medium', colour: 'white' }}>
                {t('secondSentence')}
              </Typography>
            </StackView>
          }
          placement="left"
        />
      </InlineTooltip>
    </ShouldRender>
  )
}
MonthlyChargesTooltip.defaultProps = {
  showTooltip: false
}

MonthlyChargesTooltip.propTypes = {
  showTooltip: PropTypes.bool,
  dataTestId: PropTypes.string.isRequired
}

export default MonthlyChargesTooltip
